import { useEffect, useRef, useState } from 'react';
import { Config } from 'src/config';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import InstagramDirectAuthorizationModal from './instagramDirectAuthorizationModel';
import CustomDomainRedirectIframe from '../customDomainIframe';
import { PostUtil } from 'src/pages/new-post-new/post-util';
import { useResellerLimitDialog } from 'src/components/reseller-limit-context/resellerLimitContext';

const InstagramDirectIntegration = (props) => {
  const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const { showToast } = useToaster();
  const { showResellerLimitDialog } = useResellerLimitDialog();
  let isProcessing = false;
  const isCustomDomain = CommonHelper.CustomDomain();
  let intervalId = null;
  const messageListenerRef = useRef(null);

  useEffect(() => {
    intervalId = setInterval(() => {
      checkAuthoCodeReceivedFromInstagram();
    }, Config.Common.socialAccountsIntegrationInterval);
    return () => {
      clearInterval(intervalId);
      cleanupListener();
    };
  }, []);

  const cleanupListener = () => {
    if (messageListenerRef.current) {
      window.removeEventListener('message', messageListenerRef.current, false);
      messageListenerRef.current = null; // Reset the ref
    }
  };
  const getInstagramAccounts = (code) => {
    let instagramForm = {
      code,
    };
    let postProps = {
      url: integrateModuleURL.sendDirectInstagramAuthorizationCode,
      body: instagramForm,
      successCallback: instagramDirectSuccessCallback,
      failureCallback: instagramDirectFailureCallback,
    };
    HttpServices.Post(postProps);
  };

  const getInstagramOauthToken = () => {
    window.open(
      `https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=${Config.Instagram.appId}&redirect_uri=${Config.Instagram.redirectUri}&response_type=code&scope=${Config.Instagram.scope}`,
      '_blank'
    );
  };
  const instagramDirectSuccessCallback = (data, message) => {
    CommonHelper.EnsureConversionFactorFlag(CommonHelper.ConversionFlagList.FIRST_SOCIAL_ACCOUNT_CONNECTED,"INSTAGRAM")
    showToast(message, 's');
    handleClose();
  };
  const instagramDirectFailureCallback = (message) => {
    if (!showResellerLimitDialog(message)) {
      message && showToast(message, 'e');
    }
    handleClose();
  };

  const checkAuthoCodeReceivedFromInstagram = () => {
    if (isCustomDomain) {
      const handleMessage = (event) => {
        const { type, code } = event.data;
        if (type === 'inst_auth_code' && code && !isProcessing) {
          isProcessing = true;
          cleanupListener();
          clearInterval(intervalId); // Stop polling
          getInstagramAccounts(code); // Process the code
        }
      };

      if (!messageListenerRef.current) {
        window.addEventListener('message', handleMessage, false);
        messageListenerRef.current = handleMessage; // Save the reference
      }
    } else {
      const code = localStorage.getItem('inst_autho_code');
      const error = localStorage.getItem('inst_error');
      if (code) {
        localStorage.removeItem('inst_autho_code');
        clearInterval(intervalId);
        getInstagramAccounts(code);
      } else if (error) {
        localStorage.removeItem('inst_error');
        clearInterval(intervalId);
        showToast(error, 'e');
        handleClose();
      }
    }
  };

  const handleClose = () => {
    cleanupListener();
    props.handleClose();
  };

  return (
    <>
      {isAuthorizationModalOpen && (
        <InstagramDirectAuthorizationModal handleConnectInstagram={getInstagramOauthToken} handleClose={handleClose} />
      )}
      {isCustomDomain && (
        <CustomDomainRedirectIframe serviceName="instagram" profileType={PostUtil.ProfileType.DIRECT_PROFILE} />
      )}
    </>
  );
};
export default InstagramDirectIntegration;
